import React from "react";

const TermsOfUse = () => {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h1 className="text-3xl font-semibold mb-4">Terms of Use</h1>
            <p className="text-gray-700 mb-4">
                Welcome to <span className="font-semibold">Academy-nest.com</span>. By accessing or using our platform, you agree to comply with these Terms of Use. Please read them carefully.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">1. User Accounts</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                    <span className="font-semibold">Account Registration:</span> You must provide accurate information when creating an account. Your account is personal and must not be shared with others.
                </li>
                <li>
                    <span className="font-semibold">Account Security:</span> You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.
                </li>
                <li>
                    <span className="font-semibold">Eligibility:</span> You must be at least 13 years old or meet the minimum age requirement in your country to use our platform.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">2. Usage Guidelines</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                    <span className="font-semibold">Respectful Behavior:</span> You agree to engage respectfully with teachers and other students, avoiding any form of harassment or disruptive behavior.
                </li>
                <li>
                    <span className="font-semibold">Prohibited Activities:</span> You must not upload malicious content, share illegal materials, or attempt to bypass security measures on the platform.
                </li>
                <li>
                    <span className="font-semibold">Educational Purpose:</span> Our platform is intended solely for educational use. Any other use is strictly prohibited.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">3. Payments and Refunds</h2>
            <ul className="list-disc pl-5 text-gray-700 space-y-2">
                <li>
                    <span className="font-semibold">Course Fees:</span> Payment is required to access live courses. Fees may vary based on the course.
                </li>
                <li>
                    <span className="font-semibold">Refund Policy:</span> Refunds are issued only under specific conditions, as outlined in our refund policy.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">4. Intellectual Property</h2>
            <p className="text-gray-700">
                All content on the platform, including course materials, videos, and logos, is the property of <span className="font-semibold">Academy-nest.com</span> or its licensors. You may not reproduce, distribute, or modify this content without explicit permission.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">5. Suspension or Termination</h2>
            <p className="text-gray-700">
                We reserve the right to suspend or terminate your account if you violate these Terms of Use or engage in activities that harm the platform or its users.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">6. Disclaimers and Limitation of Liability</h2>
            <p className="text-gray-700">
                While we strive to provide accurate and up-to-date content, <span className="font-semibold">Academy-nest.com</span> is not liable for any errors, interruptions, or technical issues. Your use of the platform is at your own risk.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">7. Changes to Terms</h2>
            <p className="text-gray-700">
                We may update these Terms of Use from time to time. Continued use of the platform after changes are made signifies your acceptance of the updated terms.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">8. Contact Us</h2>
            <p className="text-gray-700">
                If you have any questions about these Terms of Use, please contact us at{" "}
                <a href="mailto:support@academy-nest.com" className="text-blue-500 hover:underline">
                    support@academy-nest.com
                </a>.
            </p>
        </div>
    );
};

export default TermsOfUse;
